module.exports = __webpack_public_path__ + "media/belted-kingfisher-1.41de3bee.mp3";